import { Dispatch, SetStateAction } from "react"
import { track } from "@vercel/analytics"
import { RedeemTexts } from "@lib/handleUpdateCart"
import { View } from "@components/modals/types"
import { Config } from "@wagmi/core"

const handleRedeemProduct = async (
  config: Config,
  account: `0x${string}`,
  dbId: number,
  slicerId: number,
  productId: number,
  name: string,
  image: string,
  uid: string,
  creator: string,
  texts: RedeemTexts,
  setLoading: Dispatch<SetStateAction<boolean>>,
  setModalView: Dispatch<SetStateAction<View>>,
  shortcodes: string[],
  redeemButton: boolean | undefined
) => {
  try {
    // track("redeem_product_attempt")
    const fetcher = (await import("@utils/fetcher")).default
    const { CID } = await import("multiformats/cid")
    const { base16 } = await import("multiformats/bases/base16")
    const redeemProduct = (await import("@lib/handlers/chain/redeemProduct"))
      .default

    let purchaseHash: string

    setLoading(true)

    // Check if product has been purchased
    const redeemed = await redeemProduct(config, slicerId, productId, account)

    if (redeemed[1] != "0x") {
      purchaseHash = CID.parse("f" + redeemed[1].substring(2), base16.decoder)
        .toV1()
        .toString()
    }

    // Retrieve or apply shortcodes, if present
    let accountCodes = {}
    if (shortcodes && shortcodes?.length != 0) {
      const { data } = await fetcher(
        `/api/account/${account}/shortcodes?productId=${dbId}&codes=${shortcodes.join(
          ","
        )}`
      )

      accountCodes = data?.appliedCodes
      shortcodes.forEach((shortcode) => {
        if (!accountCodes[`${shortcode}`]) {
          accountCodes[`${shortcode}`] = "___"
        }
      })
    }

    setModalView({
      name: ""
    })

    setTimeout(() => {
      setModalView({
        name: "PURCHASE_PRODUCT_VIEW",
        cross: true,
        params: {
          slicerId,
          productId,
          name,
          image,
          purchasedQuantity: Number(redeemed[0]),
          texts,
          creator,
          uid,
          redeemButton,
          purchaseHash,
          accountCodes
        }
      })
    }, 0)
  } catch (err) {
    // track("redeem_product_fail")
    console.log(err)
  }
  setLoading(false)
}

export default handleRedeemProduct
